import { t } from '@lingui/macro'

import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { PageLink } from '@/modules/profile/components/page-link/PageLink'
import { StPageLinkWrapper } from './SignableDocumentMessage.styled'

import type { SignableDocumentDetailActivity } from '../../types/documents.types'

type Props = {
  message: SignableDocumentDetailActivity
}
export const SignableDocumentMessage = ({ message }: Props) => {
  const {
    definition: { display, message: description, url },
  } = message

  return (
    <div>
      {display ? <H2>{display}</H2> : null}
      {description ? <P type='BodyLargeRegular'>{description}</P> : null}

      {url ? (
        <StPageLinkWrapper>
          <PageLink icon={['fal', 'arrow-up-right-from-square']} external to={url}>
            {t({ id: 'read.information.link', message: 'Lees informatie' })}
          </PageLink>
        </StPageLinkWrapper>
      ) : null}
    </div>
  )
}
